import { AlertTriangle, Percent, UserX, Users } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

interface TurmaStatsCardsProps {
  turmaInfo: {
    nome: string;
    numero_sala: string;
    totalAlunos?: number;
    alunosFaltosos?: number;
    alunosPresentes?: number;
    alunosEmAtencao?: number;
    percentualPresencaHoje?: number;
  } | null;
}

export const TurmaStatsCards = ({ turmaInfo }: TurmaStatsCardsProps) => {
  if (!turmaInfo) return null;

  const chamadaRealizada = turmaInfo.percentualPresencaHoje !== undefined;
  const presencaHoje = turmaInfo.percentualPresencaHoje || 0;

  return (
    <div className="mb-4 grid grid-cols-2 gap-2 sm:mb-6 sm:grid-cols-4 sm:gap-4">
      <Card className="rounded-xl border border-slate-200 bg-white shadow-sm">
        <CardHeader className="p-3 pb-1 sm:p-5 sm:pb-2">
          <CardTitle className="flex items-center gap-2 text-xs font-medium text-slate-500 sm:text-sm">
            <Users className="h-4 w-4 text-purple-500" />
            Total
          </CardTitle>
        </CardHeader>
        <CardContent className="p-3 pt-1 sm:p-5 sm:pt-0">
          <p className="text-2xl font-bold text-purple-700 sm:text-3xl">
            {turmaInfo.totalAlunos || 0}
          </p>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-amber-200 bg-amber-50/60 shadow-sm">
        <CardHeader className="p-3 pb-1 sm:p-5 sm:pb-2">
          <CardTitle className="flex items-center gap-2 text-xs font-medium text-amber-800 sm:text-sm">
            <AlertTriangle className="h-4 w-4" />
            Em atenção
          </CardTitle>
        </CardHeader>
        <CardContent className="p-3 pt-1 sm:p-5 sm:pt-0">
          <p className="text-2xl font-bold text-amber-700 sm:text-3xl">
            {turmaInfo.alunosEmAtencao || 0}
          </p>
          <span className="text-[10px] text-amber-700/80">últimos 30 dias</span>
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-red-200 bg-red-50/60 shadow-sm">
        <CardHeader className="p-3 pb-1 sm:p-5 sm:pb-2">
          <CardTitle className="flex items-center gap-2 text-xs font-medium text-red-700 sm:text-sm">
            <UserX className="h-4 w-4" />
            Faltaram hoje
          </CardTitle>
        </CardHeader>
        <CardContent className="p-3 pt-1 sm:p-5 sm:pt-0">
          {chamadaRealizada ? (
            <p className="text-2xl font-bold text-red-600 sm:text-3xl">
              {turmaInfo.alunosFaltosos || 0}
            </p>
          ) : (
            <div>
              <p className="text-2xl font-bold text-slate-300">—</p>
              <span className="text-[10px] text-slate-400">Chamada pendente</span>
            </div>
          )}
        </CardContent>
      </Card>

      <Card className="rounded-xl border border-slate-200 bg-white shadow-sm">
        <CardHeader className="p-3 pb-1 sm:p-5 sm:pb-2">
          <CardTitle className="flex items-center gap-2 text-xs font-medium text-slate-500 sm:text-sm">
            <Percent className="h-4 w-4 text-blue-500" />
            Presença hoje
          </CardTitle>
        </CardHeader>
        <CardContent className="p-3 pt-1 sm:p-5 sm:pt-0">
          {chamadaRealizada ? (
            <p
              className={`text-2xl font-bold sm:text-3xl ${
                presencaHoje >= 75
                  ? "text-emerald-600"
                  : presencaHoje >= 50
                    ? "text-amber-600"
                    : "text-red-600"
              }`}
            >
              {presencaHoje}%
            </p>
          ) : (
            <div>
              <p className="text-2xl font-bold text-slate-300">—</p>
              <span className="text-[10px] text-slate-400">Chamada pendente</span>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
};
